import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e471a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "spinner_box",
  "data-test": "content-box-loading"
}

import Spinner from '@/components/atoms/Spinner.vue'
import { withDefaults } from 'vue'

type PropsType = {
  isLoaded?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentBox',
  props: {
    isLoaded: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.isLoaded)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Spinner)
        ]))
  ]))
}
}

})